import { Subject, from } from 'rxjs';
import { startWith, switchMap, publishReplay, refCount } from "rxjs/operators";
import { getDeviceManagerEquipments } from './getDeviceManagerEquipments';

const invalidate$ = new Subject();
export function invalidateAllDeviceManagerEquipments$() {
  invalidate$.next(null);
}

export const allDeviceManagerEquipments$ = invalidate$.pipe(
    startWith(null),
    switchMap(() => from(getDeviceManagerEquipments())),
    publishReplay(1),
    refCount()
)
